<template>
  <div class="mobile-header-container">
    <div class="mobile-header">
      <div class="header-bg" :class="webpageSetting.header_image && 'has-header-bg'">
        <video
          v-if="isHeaderVideo"
          ref="headerVideo"
          class="bg-preview"
          :src="previewFile"
          autoplay
          muted
          loop
          playsinline
          webkit-playsinline
          @canplay="playHeaderVideo"
        ></video>
        <img v-else class="bg-preview" :src="previewFile" />
        <div class="company-logo">
          <img class="logo-preview" :src="$DjangoBaseUrl(companyBaseInfo.company.logo)" />
        </div>
      </div>
      <div class="action-icon-block" :class="isPreview && 'is-preview'">
        <span class="icomoon-menu" @click="handleMobileMenuClick"></span>
        <template v-if="COMPANY_PAGE_TYPE.BRANDING === activePage">
          <span
            v-show="companyBaseInfo.show_survey_entrance"
            class="survey-icon iconfont shake-bell"
            :class="companyBaseInfo.has_answered ? 'iconcandidatesurvey-24' : 'iconcandidatesurvey-23' "
            @click="handelSurveyIconClick">
          </span>
          <span class="icomoon-location map-icon-customed" @click="handleMapClick"></span>
        </template>
      </div>
      <div class="company-info">
        <div class="company-name">{{ webpageSetting.title }}</div>
        <div class="slogan">{{ webpageSetting.slogan }}</div>
      </div>
      <MobilePersonalMenu v-if="!isPreview" :show="showMenu" :company="companyBaseInfo.company" :hideReferralProgram="hideReferralProgram" :isEmployeeAccount="isEmployeeAccount" :hasLogin="hasLogin" @change="onMenuShowChange"/>
    </div>
    <MobileMap v-if="!isPreview" :showMap.sync="showMap" :companyId="companyId"></MobileMap>
    <!-- 确认创建提醒 -->
    <JobAlertConfirmDialog
      :show.sync="showJobAlertDialog"
      :companyId="companyId"
      :logo="companyBaseInfo.company.logo"
      :isAgreed="personalAgreementStatus?.is_agreed"
    ></JobAlertConfirmDialog>
  </div>
</template>

<script>
import { getFilePath } from '@/utils/qiniu'
import { COMPANY_PAGE_TYPE, ROOT_COMPANY_ID } from '@/constant/company'
import { mapGetters } from 'vuex'
import MobileMap from './mobileMap.vue'
import JobAlertConfirmDialog from '@/components/job/jobDetail/jobAlertConfirmDialog.vue'

export default {
  components: {
    MobileMap,
    JobAlertConfirmDialog,
    MobilePersonalMenu: () => import('@/components/menu/mobilePersonalMenu.vue')
  },
  props: {
    webpageSetting: {
      type: Object,
      required: true
    },
    companyBaseInfo: {
      type: Object,
      required: true
    },
    isPreview: {
      type: Boolean,
      required: true
    },
    activePage: {
      type: String,
      required: true
    },
    showMenu: {
      type: Boolean,
      required: true
    },
    isMSDCustom: {
      type: Boolean,
      default: false
    },
    personalAgreementStatus: {
      default: null
    },
    surveyInfo: {
      default: () => { }
    }
  },
  data () {
    return {
      companyName: null,
      slogan: null,
      i18nPrefix: 'company',
      showMap: false,
      showSurvey: true,
      hasAnswered: true,
      COMPANY_PAGE_TYPE,
      showJobAlertDialog: false
    }
  },
  computed: {
    ...mapGetters('account', { currentAccount: 'getCurrentAccount' }),

    previewFile () {
      if (this.headerBackgroundImgFile) {
        return window.URL.createObjectURL(this.headerBackgroundImgFile)
      }
      return getFilePath(this.webpageSetting.header_image)
    },
    isHeaderVideo () {
      const key = this.webpageSetting.header_image
      return Boolean(key && key.toLowerCase().split('?')[0].endsWith('.mp4'))
    },
    companyId () {
      return `${this.companyBaseInfo.company.id}`
    },
    isEmployeeAccount () {
      return Boolean(this.currentAccount?.employee?.id)
    },
    hideReferralProgram () {
      return Boolean(this.currentAccount?.employee?.company.hide_referral_program)
    },
    hasLogin () {
      return Boolean(this.currentAccount?.id)
    }
  },
  created () {
  },
  mounted () {
    document.addEventListener('WeixinJSBridgeReady', this.playHeaderVideo, false)
    this.$nextTick(() => {
      this.playHeaderVideo()
    })
  },
  beforeDestroy () {
    document.removeEventListener('WeixinJSBridgeReady', this.playHeaderVideo, false)
  },
  methods: {
    playHeaderVideo () {
      const video = this.$refs.headerVideo
      if (!video) {
        return
      }

      video.muted = true
      video.defaultMuted = true

      const play = () => {
        const playPromise = video.play()
        if (playPromise) {
          playPromise.catch(() => {})
        }
      }
      const bridge = window.WeixinJSBridge
      if (bridge && typeof bridge.invoke === 'function') {
        bridge.invoke('getNetworkType', {}, play)
      } else {
        play()
      }
    },
    handleMobileMenuClick () {
      this.$emit('update:showMenu', true)
    },
    handleMapClick () {
      this.showMap = true
    },
    handelSurveyIconClick () {
      if (!this.personalAgreementStatus && this.hasLogin) {
        return
      }
      if (this.surveyInfo.survey?.has_answered) {
        if (this.companyBaseInfo.company?.root_company?.id === ROOT_COMPANY_ID.MSD) {
          this.$router.push('/msdchina/join-talent-community')
        } else {
          this.$router.push(`/recruiting/company/${this.companyId}/survey`)
        }
      } else {
        this.showJobAlertDialog = true
      }
    },
    onMenuShowChange (val) {
      this.$emit('update:showMenu', val)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/assets/scss/shake.scss';

.mobile-header-container {
  .mobile-header {
    padding-bottom: 25px;
    background-color: #fff;

    .header-bg {
      position: relative;
      width: 100%;
      height: 180px;
      background-color: #f7f7f7;

      &.has-header-bg {
        background-color: #fff;
      }

      .bg-preview {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }

      .company-logo {
        position: absolute;
        left: 50%;
        bottom: -35px;
        transform: translateX(-50%);
        width: 70px;
        height: 70px;
        background-color: #fff;
        overflow: hidden;
        border-radius: 50%;

        .logo-preview {
          width: 100%;
          height: 100%;
        }
      }
    }

    .action-icon-block {
      margin-top: 20px;
      padding: 0 15px;
      font-size: 22px;
      color: #666;
      display: flex;

      &.is-preview {
        pointer-events: none;
      }

      .icomoon-menu {
        margin-right: auto;
      }

      .icomoon-heart {
        color: var(--custom-color);
      }

      .icomoon-location {
        margin-left: 14px;
      }

      .shake-bell {
        font-size: 22px;
        margin-left: 14px;
      }
      .iconcandidatesurvey-24 {
        color: var(--custom-color);
      }
    }

    .company-info {
      margin-top: 13px;

      .company-name {
        padding: 0 15px;
        font-size: 16px;
        line-height: 22px;
        color: #333;
        font-weight: bold;
        text-align: center;
      }

      .slogan {
        margin-top: 8px;
        font-size: 15px;
        line-height: 22px;
        text-align: center;
        color: #999;
        padding: 0 15px;
      }
    }
  }
  @media screen and (min-width: 768px) {
    .mobile-header {
      .header-bg {
        height: 355px;
      }
    }
  }
}
</style>
